/**
 * Servizi per richiamare gli endpoint che forniscono dati costanti da utilizzare nell'applicazione
 * */
import {environment} from "../../environments/environment";
import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {firstValueFrom} from "rxjs";
import {User} from "../app/services/user.service";
import {BusinessUnitListResponse} from "../model/responses/BusinessUnitListResponse";
import {TipologiaUtenteEnum} from "../model/enum/TipologiaUtenteEnum";
import {MessagesService} from "../app/services/messages.service";

const BASE_URL = environment.baseUrl;

@Injectable({
  providedIn: 'root'
})
export class DataApiService {
  constructor(private httpClient: HttpClient, private messagesService: MessagesService) {
  }

  async getBusinessUnit(tipologiaUtente: TipologiaUtenteEnum): Promise<BusinessUnitListResponse> {
    return await firstValueFrom(this.httpClient.get<BusinessUnitListResponse>(`${BASE_URL}/api/business-units`, {params: {tipologiaUtente: tipologiaUtente}}))
      .then(response => {
        return response
      })
      .catch(() => {
        this.messagesService.addMessage({text: "Errore durante il recupero dei Gruppi e degli Utenti", type: "error"});
        return {listaGruppi: []}
      });
  }

  async getUserInfo(): Promise<User | undefined> {
    return await firstValueFrom(this.httpClient.get<User>(`${BASE_URL}/api/user-info`))
      .then(response => {
        return response
      })
      .catch(() => {
        return undefined
      });
  }
}
